import React from 'react';
// import { Badge, Col, Row } from 'reactstrap';
// import CardWithTitle from 'components/CardWithTitle';

const VendorFavouriteGrades = ({ favGrades }) => {
  return (
    <></>
    // <CardWithTitle title="Favourite Grades">
    //   <Row>
    //     <Col sm={8} xxl={9} className="mb-2">
    //       <span className="f -12 text-dark-525 fw-medium d-block">
    //         {favGrades.length > 0
    //           ? favGrades.map((data) => {
    //               return (
    //                 <Badge
    //                   key={data.id}
    //                   size="s"
    //                   className="me-1 text-dark fw-semibold"
    //                   color="light"
    //                 >
    //                   {data?.name}
    //                 </Badge>
    //               );
    //             })
    //           : 'Not Available'}
    //       </span>
    //     </Col>
    //   </Row>
    // </CardWithTitle>
  );
};

export default VendorFavouriteGrades;
